<template>
  <section id="jobList" class="experience">
    <h3>Work & Experience</h3>

    <div class="job-button-container">
      <div class="job-button-iterator"
           v-for="(job, index) in jobs"
           :key="index" v-bind:class="job.deploy_section ? 'deploy':''">

        <div class="job-button-wrap">
          <div class="job-button"
               @click="deploySection(index)"
               v-bind:class="job.deploy_section ? 'deploy':''"
               v-bind:style="{backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.95), rgba(220, 220, 220, 0.95)), url(' + job.logo + ')'}">
            <div class="logo">
              <img v-bind:src="publicPath + job.logo" alt="">
            </div>
            <div class="title-content">
              <div class="title"><h5>{{job.title}}</h5></div>
              <div class="company">{{job.company}}</div>
              <div class="tagline"><span>{{job.tagline}}</span></div>
              <div class="date"><span>{{job.startDate}}-{{job.endDate}}</span></div>
              <div class="rule"></div>
              <div class="description" :class="job.remove_description ? 'hide-description':'show-description'">
                {{job.description}}
              </div>
            </div>
            <div class="job-button-content-wrap">
              <div class="bullet-description"
                   v-for="(bullet,index) in job.bullets"
                   :key="index"
                   :class="bullet.bullet_visible ? 'show-bullet':'hide-bullet'">
                {{bullet.description}}
              </div>
            </div>
          </div>
          <div class="job-button-threshold">
            <div class="bullet-label-container">
              <div v-for="(bullet, bulletIndex) in job.bullets" :key="bulletIndex">
                <button class="label" @click="showBullet(index, bulletIndex)">{{bullet.label}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  var jobData = [
    {
      company: "Liberty Mutual Insurance",
      location: "Carmel, IN",
      startDate: "2/2020",
      endDate: "Current",
      title: "Senior Software Engineer",
      logo: "logos/lmig.svg",
      bullet_visible: false,
      tagline: "We believe progress happens when people feel secure.",
      description: "At Liberty Mutual Insurance we work hard every day to support our customers and our people, so they can protect their families, build their businesses and invest in their futures.",
      bullets: [
        {
          label: "Status Page",
          description: "My first project was an application status page using a node/express backend which interfaces with an AWS DocumentDB and a React front end."
        },
        {
          label: "myAudit",
          description: "MyAudit is a complete rebuild of an archaic Lotus Notes application that served as a documentation source for the auditing group.  Built on a foundation of Spring Boot and MSSQL data, the front end is built completely with React Hooks."
        }
      //   {
      //     label: "Components",
      //     description: "Integrated with the Google maps API to create customized dealer location and real estate listing components."
      //   },
      //   {
      //     label: "Secure",
      //     description: "Ensured all technology was created in a stable, secure manner to reduce our customer’s risk."
      //   },
      //   {
      //     label: "Plugin",
      //     description: "Built an in-house Chrome Plugin to assist development within the AEM User Interface."
      //   },
      //   {
      //     label: "Collaboration",
      //     description: "Collaborated with development/engineering teams across Silicon Valley, Seattle, St. Louis, Baltimore, and New York to build customer value in the CMS content and Web application development."
      //   },
      //   {
      //     label: "Project Estimation",
      //     description: "Evaluated business requirements and technical specifications to innovate and provide new and exciting solutions to exceed our client’s marketing needs."
      //   },
      //   {
      //     label: "Customer Focus",
      //     description: "Communicate with team members and clients to develop trust, promote learning and rapid adaptation within the ever changing requirements of software development."
      //   },
      //   {
      //     label: "Documentation",
      //     description: "Provided technical training/support videos for purpose-built software solutions and deployment procedures."
      //   }
      ]
    },
    {
      company: "R2 Integrated (R2i)",
      location: "Baltimore, Silicon Valley, Seattle",
      startDate: "4/2016",
      endDate: "1/2020",
      title: "Software Engineer",
      logo: "logos/r2i.svg",
      bullet_visible: false,
      tagline: "We accelerate customer connections",
      description: "In a complex world that's always demanding more, R2i is a digital agency that helps marketers create more awareness, build deeper relationships, and drive measurable impact.",
      bullets: [
        {
          label: "Backend",
          description: "Built and supported backend API’s (servlets) to interface with Adobe’s Search & Promote technology as well as Apache Sling Models, Helpers, and other workflow related functionality."
        },
        {
          label: "Accessibility",
          description: "Built hundreds of responsive, accessible (WCAG) and highly customized AEM components ranging in functionality from carousels to accordion table layouts."
        },
        {
          label: "Components",
          description: "Integrated with the Google maps API to create customized dealer location and real estate listing components."
        },
        {
          label: "Secure",
          description: "Ensured all technology was created in a stable, secure manner to reduce our customer’s risk."
        },
        {
          label: "Plugin",
          description: "Built an in-house Chrome Plugin to assist development within the AEM User Interface."
        },
        {
          label: "Collaboration",
          description: "Collaborated with development/engineering teams across Silicon Valley, Seattle, St. Louis, Baltimore, and New York to build customer value in the CMS content and Web application development."
        },
        {
          label: "Project Estimation",
          description: "Evaluated business requirements and technical specifications to innovate and provide new and exciting solutions to exceed our client’s marketing needs."
        },
        {
          label: "Customer Focus",
          description: "Communicate with team members and clients to develop trust, promote learning and rapid adaptation within the ever changing requirements of software development."
        },
        {
          label: "Documentation",
          description: "Provided technical training/support videos for purpose-built software solutions and deployment procedures."
        }
      ]
    },
    {
      company: "Apollo Education Group, Inc.",
      location: "Seattle",
      startDate: "2014",
      endDate: "2016",
      title: "Front End Developer",
      logo: "logos/Apollo-wheel.svg",
      bullet_visible: false,
      tagline: "Playing a vital role in educating the world",
      description: "Apollo Education Group is committed to leading the way in meeting the evolving needs of millions of nontraditional learners and producing the graduates necessary to achieve the world’s collective educational goals.",
      bullets: [
        {
          label:"Develop",
          description:"Developed innovative applications and Web tools for Apollo’s flagship education platform: Career Guidance System (CGS). Designed and authored custom directives, CSS animations, and user experience (UX) elements such as contextual help pages and instructional models. Collaborated with database developers to establish Ajax API calls."},
        {
          label:"Teamwork",
          description:"Web Application Innovation: Served on strategic team that developed core solutions for Career Guidance System, including Career Explorer tool, Job Search tool, Resume Builder tool, and Skill Builder tool."},
        {
          label:"AEM",
          description:"Developed CGS and components in Adobe Experience Manager with modular components for adaptability, enabling rapid configuration and customization for company and educational institution branding."},
        {
          label:"Interaction",
          description:"Created complex job search alerts application with rich and interactive Web user interface/user experience features and email subscription management functionality in AEM."},
        {
          label:"AngularJS",
          description:"Served on Angular Team and performed re-development of CGS version 3.0, built prototypes for delivering rich functionality in modular, single-page application framework."
        }
      ]
    },
    {
      company: "Maroon Product Development LLC",
      location: "Phoenix",
      startDate: "2004",
      endDate: "2014",
      title: "Industrial Designer",
      logo: "logos/MPD-logo.svg",
      bullet_visible: false,
      tagline: "Full-Service Industrial Design Consultancy",
      description: "Developed consumer products from a wide-ranging array of clientele",
      bullets: [
        {
          label:"Consultant",
          description:"Directed launch and growth of product design and development organization focused on bringing novel consumer and industrial products from concept to market."},
        {
          label:"Development",
          description:"Navigated products through all phases of design, development, and production launch."},
        {
          label:"Collaboration",
          description:"Collaborated with customer stakeholders in creation of product roadmap, design specifications, prototype development and design optimization, and manufacturing hand-off."},
        {
          label:"Customer",
          description:"Managed engagements with clients and inventors, representing their interests with manufacturing partners."}
      ]
    }
  ];
  for (var job in jobData) {
    jobData[job].deploy_section = false;
    jobData[job].remove_description = false;
    for(var bullet in jobData[job].bullets) {
      jobData[job].bullets[bullet].bullet_visible = false;
    }
  }
  export default {
    beforeMount() {},
    methods: {
      turnOffBullets: function(index) {
        for(var bullet in this.jobs[index].bullets) {
          this.jobs[index].bullets[bullet].bullet_visible = false;
        }
      },
      closeAllSections: function(){
        for (var job in this.jobs) {
          this.jobs[job].deploy_section = false;
        }
      },
      checkForDeployedSections: function() {
        for (var job in this.jobs) {
          if(this.jobs[job].deploy_section) {
            return true;
          }
        }
      },
      deploySection: function (index) {
        if (this.jobs[index].deploy_section === true) {
          this.turnOffAllBullets();
          this.turnOnDescription(index);
          this.jobs[index].deploy_section =false;
        } else if(this.checkForDeployedSections()) {
          this.turnOffAllBullets();
          this.closeAllSections();
          this.turnOnDescription(index);
          var self = this;
          setTimeout(function(){
            self.jobs[index].deploy_section = !self.jobs[index].deploy_section;
          },200);
        } else {
          this.turnOffAllBullets();
          this.jobs[index].deploy_section = !this.jobs[index].deploy_section;
        }
      },
      turnOffAllBullets: function() {
        for (var job in this.jobs) {
          for (var bullet in this.jobs[job].bullets) {
            this.jobs[job].bullets[bullet].bullet_visible = false;
          }
        }
      },
      turnOnDescription: function(index) {
        this.jobs[index].remove_description = false;
      },
      toggleDescription: function(index) {
        if (!this.jobs[index].remove_description) {
          this.jobs[index].remove_description = true;
        }
      },
      showBullet: function (index, bulletIndex) {
        this.turnOffBullets(index);
        this.toggleDescription(index);
        this.jobs[index].bullets[bulletIndex].bullet_visible = !this.jobs[index].bullets[bulletIndex].bullet_visible;
      }
    },
    data: function() {
      return {
        loaded: false,
        publicPath: process.env.BASE_URL,
        jobs:jobData
      };
    }
  }
</script>

